import * as actionTypes from '../action-types';

export const toggleSearchMenu = () =>
  <const>{
    type: actionTypes.TOGGLE_SEARCH_MENU,
  };

export type SearchMenuActions = ReturnType<typeof toggleSearchMenu>;
